import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getTranslatedText } from '../../../helpers/checkTranslations';
import { store } from '../../../redux/store';
import { default as plus } from '../plus-sign.svg';
const Modifiers = () => {

    return (
        <>
            <Link to="/modifiers">
                <p data-component="provider">
                    {getTranslatedText('modifiers', store)}
                </p>
            </Link>
            <Link to={'/add-modifier'}>
                <button className="btn add-btn">
                    <span>
                        <img src={plus} alt="add" />
                    </span>
                </button>
            </Link>
        </>
    );
};
export default Modifiers;
